import React from 'react'

export default function TeacherHeadSubItem(props) {
    return (
        <li className={`list-item ${props.active ? "active" : ""}`}>
            <img src={require("./images/mn_tea_sub_" + props.index + ".png").default} alt="" />
        </li>
    )
}
